<template>
    <modal id="delete-user" color="red">
        <template slot="title">Delete User</template>
        <template slot="body">
            Do you want to delete the user <strong v-text="user.full_name"></strong>?
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-default" @click="closeModal('delete-user')">Cancel</button>
            <button type="button" class="btn btn-danger" :disabled="form.isSubmitted" @click="save()" >Delete</button>
        </template>
    </modal>
</template>

<script>
    export default {

        props: {
            users: {
                type: Array,
                required: true,
            },
            user: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                form: new Form({})
            }
        },

        methods: {

            save() {
                this.form.delete(`/management/users/${this.user.slug}`).then(response => {
                    var index = this.users.indexOf(this.user);
                    this.users.splice(index, 1);
                    this.closeModal('delete-user');
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            },
        }
    }
</script>
